// src/components/ui/ErrorMessage.js
import React from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';

/**
 * Exibe uma mensagem de erro em destaque.
 */
export const ErrorMessage = ({ error, type = 'critical' }) => {
    // Se não houver erro, não renderiza nada
    if (!error) return null;
    
    // Tratamento para garantir que error seja uma string
    const message = typeof error === 'string' ? error : error.message || JSON.stringify(error);
    
    // Verifica se é um erro de permissão específico do Firestore
    const isPermissionError = message.includes("Permissão") || message.includes("permission-denied") || message.includes("Missing or insufficient permissions");

    const icon = isPermissionError ? AlertTriangle : XCircle;
    const bgColor = isPermissionError ? 'bg-yellow-50' : 'bg-red-50';
    const borderColor = isPermissionError ? 'border-yellow-200' : 'border-red-200';
    const textColor = isPermissionError ? 'text-yellow-800' : 'text-red-800';
    const iconColor = isPermissionError ? 'text-yellow-600' : 'text-red-600';
    const title = isPermissionError ? 'Acesso Restrito' : 'Erro Encontrado';

    return (
        <div className={`p-4 ${bgColor} border-l-4 ${borderColor} rounded-r-xl max-w-2xl mx-auto mt-6 shadow-sm flex items-start space-x-4 animate-fade-in`}>
            {React.createElement(icon, { className: `w-6 h-6 flex-shrink-0 ${iconColor} mt-1` })}
            
            <div className="flex-1">
                <h2 className={`text-base font-bold ${textColor} mb-1`}>{title}</h2>
                <p className={`text-sm ${textColor} opacity-90 whitespace-pre-wrap break-words`}>{message}</p>
                
                {isPermissionError && (
                    <p className="text-xs mt-2 font-bold text-yellow-700 bg-yellow-100 p-2 rounded inline-block">
                        Dica: Verifique as regras de segurança (Firestore Rules) no console do Firebase.
                    </p>
                )}
            </div>
        </div>
    );
};

export default ErrorMessage;